import React, { useCallback } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { IconButton } from '@atlaskit/button/new';

import CrossIcon from '@atlaskit/icon/core/cross';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const exitButtonStyles = cssMap({
	root: {
		position: 'absolute',
		top: token('space.200'),
		right: token('space.200'),
		zIndex: 100,
	},
});

type ExitButtonProps = {
	onClose: () => void;
};

export const ExitButton = ({ onClose }: ExitButtonProps) => {
	const { formatMessage } = useIntl();

	const handleClose = useCallback(
		(_: React.MouseEvent<HTMLButtonElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => {
			onClose();
			fireUIAnalytics(analyticsEvent, 'cross');
		},
		[onClose],
	);

	return (
		<Box xcss={exitButtonStyles.root}>
			<IconButton
				label={formatMessage(messages.exit)}
				icon={CrossIcon}
				onClick={handleClose}
				appearance="subtle"
			/>
		</Box>
	);
};
